import ShotLocations from '../../../domain/models/shot-locations';
import { SlShotLocations } from '../schema';

const toShotLocations = (
	slShotLocations: SlShotLocations,
	shotsTaken: number
) => new ShotLocations(slShotLocations, shotsTaken);

export default toShotLocations;
